import script from "./ClosetManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosetManage.vue?vue&type=script&setup=true&lang=js"

import "./ClosetManage.vue?vue&type=style&index=0&id=a201719c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a201719c"]])

export default __exports__